import { createBrowserClient } from '@supabase/ssr';

/** Wipe every Supabase auth cookie + localStorage entry without any network call. */
export function clearLocalAuthSession(): void {
  if (typeof document !== 'undefined') {
    document.cookie.split(';').forEach((c) => {
      const name = c.trim().split('=')[0];
      if (name && name.startsWith('sb-') && name.includes('auth-token')) {
        document.cookie = `${name}=; Path=/; Max-Age=0; SameSite=Lax`;
      }
    });
  }
  try {
    Object.keys(localStorage).forEach((k) => {
      if (k.startsWith('sb-') || k.startsWith('sb_')) {
        localStorage.removeItem(k);
      }
    });
  } catch {
    // ignore
  }
}

/** Module-level singleton — reuse the same client across all renders. */
let _browserClient: ReturnType<typeof createBrowserClient> | null = null;

export function getBrowserClient() {
  if (!_browserClient) {
    _browserClient = createBrowserClient(
      process.env.NEXT_PUBLIC_SUPABASE_URL!,
      process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!
    );
  }
  return _browserClient;
}

export function createClient() {
  return getBrowserClient();
}
